import React from 'react' 
export const skeletonBreadcrumb = (<div className='mp-breadcrumb-skeleton'/>)